module.exports = __webpack_public_path__ + "static/media/YB5M03_3.5a336fd0.jpg";